module.exports = __webpack_public_path__ + "img/metaverse.a8aac146.jpg";